import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, NgZone, inject } from '@angular/core';

import { DsTouchClickDirective } from '@frontend/ui/shared';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

import { SwipeDirection, SwipeDirective } from '../browser/swipe.directive';
import { DynamicHtmlDirective } from '../dynamic-layout/dynamic-html.directive';

/**
 * @stable
 */
@Component({
    imports: [DynamicHtmlDirective, SwipeDirective, DsTouchClickDirective],
    selector: 'vn-toastr',
    templateUrl: 'toastr.html',
    animations: [
        trigger('flyInOut', [
            state('inactive', style({ opacity: 0 })),
            state('active', style({ opacity: 1 })),
            state('swiped-right', style({ transform: 'translateX(100%)' })),
            state('removed', style({ opacity: 0 })),
            transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
            transition('active => swiped-right', animate('{{ easeTime }}ms {{ easing }}')),
        ]),
    ],
})
export class ToastrComponent extends Toast {
    constructor() {
        const toastrService = inject(ToastrService);
        const toastPackage = inject(ToastPackage);
        const zone = inject(NgZone);

        super(toastrService, toastPackage, zone);
    }

    onSwipe(direction: SwipeDirection) {
        if (direction === SwipeDirection.Right) {
            this.state = { ...this.state, value: 'removed' };
            this.outsideTimeout(() => this.remove(), +this.toastPackage.config.easeTime);
        }
    }
}
